export enum FileSizeEnum {
    'large' = '-900X900',
    'medium' = '-600X600',
    'small' = '-300X300'
}
